import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "frame", "resultItem", "resultItemList"];
  static values = { url: String };

  search() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.frameTarget.src = `${this.urlValue}?q=${encodeURIComponent(this.inputTarget.value)}`;
    }, 300);
  }

  handleKeydown(event) {
    switch (event.key) {
      case "Escape":
        this.dismiss();
        break;
      case "ArrowDown":
        event.preventDefault();
        this.setSelectedItem(this.selectedItemIndex + 1);
        break;
      case "ArrowUp":
        event.preventDefault();
        this.setSelectedItem(this.selectedItemIndex - 1);
        break;
      case "Enter":
        event.preventDefault();
        this.selectedItem()?.click();
        break;
    }
  }

  resultChosen() {
    setTimeout(() => this.dismiss(), 0);
  }

  dismiss() {
    clearTimeout(this.searchTimeout);
    this.frameTarget.removeAttribute("src");
    this.frameTarget.innerHTML = "";
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }

  resultItemListTargetConnected() {
    this.setSelectedItem(0);
  }

  selectHoveredItem(event) {
    this.setSelectedItem(this.resultItemTargets.indexOf(event.currentTarget));
  }

  selectedItem() {
    return this.resultItemTargets[this.selectedItemIndex];
  }

  setSelectedItem(index) {
    if (this.resultItemTargets[index] === undefined) return;

    this.selectedItemIndex = index;
    this.resultItemTargets.forEach((item) => item.classList.remove("active"));
    this.resultItemTargets[index].classList.add("active");
    this.resultItemTargets[index].scrollIntoView({ block: "nearest", behavior: "smooth" });
  }
}
